import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useEffect, useState } from 'react';

type ConfirmationDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string; // Optional: Title of the dialog
  description?: string; // Optional: Description message of the dialog
  confirmText?: string; // Optional: Text for the confirm button
  cancelText?: string; // Optional: Text for the cancel button
  delayAction?: boolean;
  level?: string; // Optional: Level of alert dialog
};

export default function ConfirmationDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action', // Default title
  description = 'Are you sure you want to proceed?', // Default description
  confirmText = 'Confirm', // Default confirm button text
  cancelText = 'Cancel', // Default cancel button text
  delayAction = false,
  level = 'info',
}: ConfirmationDialogProps) {
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;

    if (delayAction) {
      setIsDisabled(true);
      timer = setTimeout(() => {
        setIsDisabled(false);
      }, 3000);
    } else {
      setIsDisabled(false);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [delayAction]);

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className={level === 'destructive' ? 'text-destructive' : ''}>{title}</AlertDialogTitle>
          <AlertDialogDescription>
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>{cancelText}</AlertDialogCancel>
          <AlertDialogAction
            disabled={isDisabled}
            className={level === 'destructive' ? 'bg-destructive hover:bg-destructive/90' : ''}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
